"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M20.934 10.24l-1.773-4.4a1.8 1.8 0 00-1-1.001l-4.4-1.773a.904.904 0 00-.978.2l-9.516 9.516a.905.905 0 000 1.283l6.668 6.668a.905.905 0 001.283 0l9.516-9.516a.898.898 0 00.2-.976zm-4.297-.995a1.33 1.33 0 11-1.882-1.882 1.33 1.33 0 011.882 1.882z" }), "Tag");
//# sourceMappingURL=Tag.js.map